import React, { useEffect, useRef, useState } from "react";
import iconeAdd from "../../../../assets/IconeSvg/boutonAdd.svg";
import iconethreeDots from "../../../../assets/IconeSvg/treeDotsGray.svg";
import iconeDelete from "../../../../assets/IconeSvg/delete.svg";
import iconePencil from "../../../../assets/IconeSvg/pencil.svg";
import iconeCloseWindow from "../../../../assets/IconeSvg/close_window.svg";
import iconeAppareilPhoto from "../../../../assets/IconeSvg/appareil_photo.svg";
import iconeSearch from "../../../../assets/IconeSvg/search.svg";
import { Drawer, Pagination, Snackbar } from "@mui/material";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import {
  enregistrerMarques,
  listeDesMarques,
  modifierMarqueById,
  supprimerUneMarque
} from "../../../../services/parametrage/MarqueRequest";
import fr from "date-fns/locale/fr";

function formatDateToFrench(dateString) {
  const date = new Date(dateString);

  // Options for the French date format
  const options = {
    day: "2-digit",
    month: "long",
    year: "numeric"
  };

  // Format the date to French locale
  return date.toLocaleDateString("fr-FR", options);
}

const Marques = () => {
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 10,
    nombrePage: 1,
    pagePagination: 1
  });

  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [filePhoto, setFilePhoto] = useState(null);

  const [addLoading, setAddLoading] = useState(false);
  const [loadingActivation, setLoadingActivation] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  const [listeAllMarques, setListeAllMarques] = useState([]);
  const [searchParam, setSearchParam] = useState("");
  const [designation, setDesignation] = useState("");
  const [description, setDescription] = useState("");
  const [dateDebut, setDateDebut] = useState(new Date());
  const [dateFin, setDateFin] = useState(new Date());
  const [MarqueInfos, setMarqueInfos] = useState(null);

  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center"
  });
  const { vertical, horizontal } = snackbarPosition;

  // Upload photo de profil
  const handleClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFilePhoto(file);
      console.log("nouvelle image :", file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreview(e.target.result);
      };

      console.log(preview);
      reader.readAsDataURL(file);
    }
  };

  const TableElement = ({ MarqueItem }) => {
    return (
      <tr className=" bg-white">
        <td className="px-4 truncate text-sm text-stone-500 font-medium">
          <img
            src={MarqueItem.image ? MarqueItem.image : "-"}
            alt=""
            className="w-10 h-10"
          />
        </td>
        <td className="px-4 truncate text-sm text-stone-500 font-medium">
          {MarqueItem.nom ? MarqueItem.nom : "-"}
        </td>

        <td className="px-4">
          <div className="dropdown dropdown-left dropdown-end">
            <div
              tabIndex={0}
              className="w-7 h-7 rounded-lg bg-gray-200 flex items-center justify-center cursor-pointer"
            >
              <img src={iconethreeDots} alt="" />
            </div>
            <ul
              tabIndex={0}
              className="dropdown-content z-50 menu p-1 shadow border bg-white rounded-lg w-32 mr-2"
            >
              <button
                onClick={() => {
                  setMarqueInfos(MarqueItem);
                  openModalModif(MarqueItem);
                }}
                className="w-full h-9 px-2 hover:bg-zinc-100 flex gap-x-1 items-center justify-start rounded-md"
              >
                <img src={iconePencil} alt="" className="w-5" />
                <span className="font-semibold text-sm">Modifier</span>
              </button>

              <button
                onClick={() => {
                  setMarqueInfos(MarqueItem);
                  document.getElementById("detele_Marque").showModal();
                }}
                className="w-full h-9 px-2 hover:bg-zinc-100 flex gap-x-1 items-center justify-start rounded-md"
              >
                <img src={iconeDelete} alt="" className="w-5" />
                <span className="font-semibold text-sm">Supprimer</span>
              </button>
            </ul>
          </div>
        </td>
      </tr>
    );
  };

  const openModalModif = (MarqueItem) => {
    setOpenModal(true);
    setMarqueInfos(MarqueItem);
    setDesignation(MarqueItem.nom);
    setFilePhoto(MarqueItem.image);
  };

  // === VIDE FORMULAIRE ===
  const clearFormEnregistrement = () => {
    setMarqueInfos(null);
    setAddLoading(false);
    setDesignation("");
    setPreview(null);
  };

  // === RECUPERE LISTE DES MarqueS ===
  const getListeDesMarques = () => {
    setLoadingData(true);
    // pageQuery.page, pageQuery.size, ""
    listeDesMarques(pageQuery.page, pageQuery.size, "")
      .then((res) => {
        setLoadingData(false);
        console.log(res);
        setListeAllMarques(res.data.marques);
        setPageQuery({
          ...pageQuery,
          nombrePage: res.data.totalPages
        });
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error recontrer ===== :", error);
      });
  };

  // === ENREGISTRE UNE Marque ===
  const handleMarque = () => {
    setAddLoading(true);
    const dataMarque = new FormData();
    dataMarque.append("nom", designation);
    dataMarque.append("image", filePhoto);

    enregistrerMarques(dataMarque)
      .then((res) => {
        clearFormEnregistrement();
        setAddLoading(false);
        setOpenModal(false);
        setSuccessMessage("marque enregistréee avec succès.");
        setSnackbarOpenSuccess(true);
      
        getListeDesMarques();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response.data) {
          setErrorMessage(err.response.data.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("ELEMENT", err);
      });
  };

  // === MODIFIER UNE Marque ===
  const modifierMarque = () => {
    setAddLoading(true);

    const dataMarque = new FormData();
    dataMarque.append("nom", designation);
    dataMarque.append("image", filePhoto);
    

    modifierMarqueById(MarqueInfos._id, dataMarque)
      .then((res) => {
        clearFormEnregistrement();
        setAddLoading(false);
        setOpenModal(false);
        setPreview(null);
        setSuccessMessage("marque modifiée avec succès.");
        setSnackbarOpenSuccess(true);
        getListeDesMarques();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response && err.response.data) {
          setErrorMessage(err.response.data.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("ELEMENT", err);
      });
  };

  // === RENDRE ANNÉE ACTIVE ===
  // const modifierEtatDeAnneeScolaire = () => {
  //   setLoadingActivation(true);
  //   rendreAnneeActive(MarqueInfos._id)
  //     .then((res) => {
  //       setLoadingActivation(false);
  //       setSuccessMessage("Année catéchétique activée avec succès.");
  //       setSnackbarOpenSuccess(true);
  //       getListeDesAnneesCatechumique();
  //       document.getElementById("annee_active").close();
  //     })
  //     .catch((err) => {
  //       setLoadingActivation(false);
  //       if (err && err.response && err.response.data) {
  //         setErrorMessage(err.response.data.message);
  //         setSnackbarOpenError(true);
  //       } else {
  //         setErrorMessage("Erreur d'enregistrement, rééssayer!");
  //         setSnackbarOpenError(true);
  //       }
  //       console.log("ELEMENT", err);
  //     });
  // };

  // === SUPPRIMER Marque ===
  const supprimerMarque = () => {
    setDeleteLoading(true);

    supprimerUneMarque(MarqueInfos._id)
      .then((res) => {
        setSuccessMessage("marque supprimée avec succès");
        getListeDesMarques();
        setSnackbarOpenSuccess(true);
        setDeleteLoading(false);
        document.getElementById("detele_Marque").close();
      })
      .catch((err) => {
        setDeleteLoading(false);
        if (err && err.response && err.response.data) {
          setErrorMessage(err.response.data.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  // === FILTRER LES ELEMENTS ===
  const filterElement = () => {
    setSearchLoading(true);

    listeDesMarques(pageQuery.page, pageQuery.size, searchParam)
      .then((res) => {
        setSearchLoading(false);
        setListeAllMarques(res.data.marques);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalElements
        }));
      })
      .catch((error) => {
        setSearchLoading(false);
        console.log("error", error);
      });
  };

  // === PAGINATION DES ELEMENTS ===
  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value
    }));
    // listeDesAnneesCatechumiquePaginee(value, pageQuery.size, searchParam)
    listeDesMarques(value, pageQuery.size, searchParam)
      .then((res) => {
        setLoadingData(false);
        setListeAllMarques(res.data.marques);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalMarques
        }));
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error", error);
      });
  };

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  useEffect(() => {
    getListeDesMarques();
  }, []);

  return (
    <div className="w-full h-full">
      <div className="flex flex-col sm:flex-row justify-end items-end sm:items-center gap-2">
        <div className="w-full sm:w-fit flex items-center gap-x-2">
          <input
            type="text"
            placeholder="Rechercher un élement..."
            value={searchParam}
            onChange={(e) => setSearchParam(e.target.value)}
            className="input input-bordered w-11/12 sm:w-56 h-10 text-sm font-medium"
          />
          <button
            disabled={searchLoading}
            className="bg-gray-600 text-sm text-white h-10 w-fit px-4 font-semibold rounded-xl flex items-center justify-center"
            onClick={filterElement}
          >
            {!searchLoading ? (
              "Rechercher"
            ) : (
              <ThreeDots
                height="35"
                width="35"
                radius="9"
                color="#fff"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={searchLoading}
              />
            )}
          </button>
        </div>
        <button
          onClick={() => {
            clearFormEnregistrement();
            setOpenModal(true);
          }}
          className="bg-primary w-full sm:w-fit h-10 px-4 flex items-center justify-center gap-x-2 rounded-xl"
        >
          <img src={iconeAdd} alt="" className="w-5 sm:w-auto" />
          <span className="text-white text-sm font-semibold truncate">
            Ajouter une marque
          </span>
        </button>
      </div>

      <div className="mt-2 w-full h-full">
        <div className="overflow-x-auto">
          <table className="custom-table table table-zebra w-full">
            <thead>
              <tr className="bg-black h-12">
                <th className="text-sm text-white">Image</th>
                <th className="text-sm text-white">Désignation</th>
                {/* <th className="text-sm text-white">Description</th> */}
                <th className="text-sm text-white">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loadingData && listeAllMarques.length > 0 ? (
                listeAllMarques.map((item) => (
                  <TableElement key={item._id} MarqueItem={item} />
                ))
              ) : !loadingData && listeAllMarques.length === 0 ? (
                <tr>
                  <td colSpan="7">
                    <div className="w-full h-32 bg-white flex gap-x-2 text-red-500 items-center justify-center">
                      <p className="font-semibold text-lg text-red-600">
                        Aucun élément trouvé
                      </p>
                    </div>
                  </td>
                </tr>
              ) : loadingData && listeAllMarques.length === 0 ? (
                <tr>
                  <td colSpan="7">
                    <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                      <TailSpin
                        height="30"
                        width="30"
                        color="#000"
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={loadingData}
                      />
                    </div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan="7">
                    <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                      <TailSpin
                        height="30"
                        width="30"
                        color="#000"
                        ariaLabel="tail-spin-loading"
                        radius="1"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={loadingData}
                      />
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end mt-2">
          <Pagination
            count={pageQuery.nombrePage}
            page={pageQuery.pagePagination}
            variant="outlined"
            shape="rounded"
            onChange={handlePaginationChange}
          />
        </div>
      </div>

      <Drawer
        anchor={"right"}
        open={openModal}
        onClose={() => setOpenModal(false)}
      >
        <div className="w-full sm:w-[430px] p-4 flex flex-col bg-white h-full">
          <div className="flex flex-row  justify-start items-center gap-3 mb-6">
            <button onClick={() => setOpenModal(false)}>
              <img src={iconeCloseWindow} alt="" />
            </button>

            <h2 className=" text-xl font-extrabold">
              {MarqueInfos === null
                ? " Ajouter une marque"
                : "Modifier cette marque"}
            </h2>
          </div>

          <div className="flex justify-center items-center  mt-6 h-24 w-full ">
            <div
              onClick={handleClick}
              className="flex justify-center items-center w-40 h-40 bg-[#F9F9F9] rounded-full cursor-pointer"
            >
              {preview && (MarqueInfos !== null || MarqueInfos === null) ? (
                <div className="relative ">
                  <div className="absolute bg-[#0000009a]  w-40 h-40 rounded-full flex justify-center">
                    <img src={iconeAppareilPhoto} className="w-8" alt="" />
                  </div>
                  <img
                    src={preview}
                    alt="Preview"
                    className="w-40 h-40 rounded-full"
                  />
                </div>
              ) : preview === null && MarqueInfos !== null ? (
                <div className="relative">
                  <div className="absolute bg-[#00000079]  w-40 h-40 rounded-full flex justify-center">
                    <img src={iconeAppareilPhoto} className="w-8" alt="" />
                  </div>
                  <img
                    src={MarqueInfos && MarqueInfos.image}
                    alt=""
                    className="w-40 h-40 rounded-full"
                  />
                </div>
              ) : (
                <div className="w-20 h-20 rounded-full flex justify-center">
                  <img src={iconeAppareilPhoto} className="w-8" alt="" />
                </div>
              )}
            </div>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </div>

          <div className="mt-6">
            <div>
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-bold text-gray-500 text-sm">
                    Désignation
                  </span>
                </div>
                <input
                  type="text"
                  value={designation}
                  onChange={(e) => setDesignation(e.target.value)}
                  disabled={addLoading}
                  placeholder="Entrer le nom"
                  className="input input-bordered w-full h-10 font-medium bg-[#F9F9F9]"
                />
              </label>
              {/* <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-bold text-gray-500 text-sm">
                    description
                  </span>
                </div>
                <input
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={addLoading}
                  placeholder="Entrer le nom"
                  className="input input-bordered w-full h-10 font-medium bg-[#F9F9F9]"
                />
              </label> */}
            </div>

            <button
              onClick={
                MarqueInfos === null
                  ? () => handleMarque()
                  : () => modifierMarque()
              }
              disabled={addLoading}
              className="mt-8 bg-primary flex items-center justify-center w-full h-11 font-bold text-white rounded-lg hover:drop-shadow-md"
            >
              {!addLoading ? (
                <span>{MarqueInfos === null ? "Enregistrer" : "Modifier"}</span>
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={addLoading}
                />
              )}
            </button>
          </div>
        </div>
      </Drawer>

      <dialog id="annee_active" className="modal">
        <div className="modal-box rounded-lg">
          <form method="dialog">
            <button className="w-7 h-7 absolute right-2 top-2">
              <img
                onClick={() => setMarqueInfos(null)}
                src={iconeCloseWindow}
                className="cursor-pointer w-full"
                alt=""
              />
            </button>
          </form>
          <h3 className="font-extrabold text-xl text-center text-green-600">
            Modifier cette marque
          </h3>
          <div className="pt-4 pb-2">
            <p className="text-center text-base font-medium text-gray-600">
              Attention cette action rendra cette marque active pour toutes les
              opérations effectuées dans l'application.
            </p>
          </div>
          <div className="modal-action flex justify-center">
            <form
              method="dialog"
              className="w-full flex flex-col sm:flex-row justify-center gap-x-3"
            >
              {/* if there is a button in form, it will close the modal */}
              {loadingActivation ? (
                <div
                  disabled={loadingActivation}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </div>
              ) : (
                <button
                  disabled={loadingActivation}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </button>
              )}
              <div
                // onClick={modifierEtatDeAnneeScolaire}
                disabled={loadingActivation}
                className="mt-2 sm:mt-0 w-full sm:w-56 px-2 h-10 bg-green-600 text-white text-sm rounded-lg flex items-center justify-center font-semibold cursor-pointer"
              >
                {!loadingActivation ? (
                  "Rendre active"
                ) : (
                  <ThreeDots
                    height="40"
                    width="40"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={loadingActivation}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
      </dialog>

      {/* MODAL DELETE Marque   */}
      <dialog id="detele_Marque" className="modal">
        <div className="modal-box rounded-lg">
          <form method="dialog">
            <button className="w-7 h-7 absolute right-2 top-2">
              <img
                onClick={() => setOpenModal(false)}
                src={iconeCloseWindow}
                className="cursor-pointer w-full"
                alt=""
              />
            </button>
          </form>
          <h3 className="font-extrabold text-xl text-center text-primary">
            Supprimer cette marque
          </h3>
          <div className="pt-4 pb-2">
            <p className="text-center text-base font-medium text-gray-600">
              Attention action est irrversible et entrainera la suppression de
              cette marque
            </p>
          </div>
          <div className="modal-action flex justify-center">
            <form
              method="dialog"
              className="w-full flex flex-col sm:flex-row justify-center gap-x-3"
            >
              {/* if there is a button in form, it will close the modal */}
              {deleteLoading ? (
                <div
                  disabled={deleteLoading}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </div>
              ) : (
                <button
                  disabled={deleteLoading}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </button>
              )}
              <div
                onClick={supprimerMarque}
                disabled={deleteLoading}
                className="mt-2 sm:mt-0 w-full sm:w-56 px-2 h-10 bg-primary text-white text-sm rounded-lg flex items-center justify-center font-semibold cursor-pointer"
              >
                {!deleteLoading ? (
                  "Supprimer quand même"
                ) : (
                  <ThreeDots
                    height="40"
                    width="40"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={deleteLoading}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
      </dialog>

      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
          className="z-[999999]"
        >
          <div className="bg-green-500 text-white font-semibold z-[999999] px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
          className="z-[999999]"
        >
          <div className="bg-red-500 text-white font-semibold z-[999999] px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </div>
  );
};

export default Marques;
